export default __webpack_public_path__ + "static/media/ocr_file_upload_error.a0c1d336.svg";